'use strict';
define([
    'angular',
    'modules/seochecker/results/content/content.controller'
],function(angular,SEOCheckerContentController){
    var app=angular.module('app.seochecker.results.content', []);
    app.controller('SEOCheckerContentController',SEOCheckerContentController);
    return app;
});
